import { AssetVersionDto } from '@nusign/picflow-backend-types';

export const estimateResizedAssetSize = (versionData: AssetVersionDto, shortEdge: number) => {
  if (!versionData.data.width || !versionData.data.height) return BigInt(0);
  const aspect = versionData.data.width / versionData.data.height;

  let width: number, height: number;

  if (aspect < 1) {
    width = Math.min(shortEdge, versionData.data.width);
    height = width / aspect;
  } else {
    height = Math.min(shortEdge, versionData.data.height);
    width = height * aspect;
  }
  return BigInt(Math.round((width * height) / (1 + Math.pow(width * height, 0.15))));
};
